import { z } from 'zod';
import { encodeBody } from '../http/encode.js';
import { Dec } from '../numeric/decimal.js';
import { conversionPreviewSchema, uomConversionCreateSchema, uomConversionSchema, uomCreateSchema, uomSchema, } from '../schemas/uom.js';
const uomListSchema = z.array(uomSchema);
const conversionListSchema = z.array(uomConversionSchema);
export class UomApi {
    transport;
    constructor(transport) {
        this.transport = transport;
    }
    list(signal) {
        return this.transport.request({
            method: 'GET',
            path: '/v1/uoms',
            schema: uomListSchema,
            signal,
        });
    }
    create(payload, operation, signal) {
        return this.transport.request({
            method: 'POST',
            path: '/v1/uoms',
            body: encodeBody(uomCreateSchema, payload, 'createUom'),
            operation,
            schema: uomSchema,
            signal,
        });
    }
    listConversions(itemId, signal) {
        return this.transport.request({
            method: 'GET',
            path: '/v1/uoms/conversions',
            query: { item_id: itemId },
            schema: conversionListSchema,
            signal,
        });
    }
    createConversion(payload, operation, signal) {
        return this.transport.request({
            method: 'POST',
            path: '/v1/uoms/conversions',
            body: encodeBody(uomConversionCreateSchema, payload, 'createUomConversion'),
            operation,
            schema: uomConversionSchema,
            signal,
        });
    }
    /**
     * Convert a quantity **on the server**, using the same pure function the ledger will use.
     *
     * There is deliberately no client-side equivalent in this package. Chains compose
     * (1 CASE = 4 BOX = 48 NOS), item overrides beat global rules, dimensions are never
     * crossed, and rounding happens once at the end rather than per hop. Reimplementing any
     * of that in a browser gives a picker one number and the ledger another.
     */
    convert(params, signal) {
        return this.transport.request({
            method: 'GET',
            path: '/v1/uoms/convert',
            query: {
                quantity: Dec.parse(params.quantity),
                from_uom_id: params.from_uom_id,
                to_uom_id: params.to_uom_id,
                item_id: params.item_id,
            },
            schema: conversionPreviewSchema,
            signal,
        });
    }
}
//# sourceMappingURL=uom.js.map